import React from 'react';
import { Button as UDSButton } from '@telus-uds/components-web';

import PropTypes from 'prop-types';

import Regular from './Regular';
import TwoYear from './TwoYear';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { StatusBarWrapper, ButtonsWrapper, Button as ButtonWrapper, Flex } from '../css';
import {
  fieldSubscriberDetailsDevicePlan,
  fieldSubscriberDetailsContractTerm,
  contractTerm3Year
} from '../../../utils/constant';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

import { getFieldValue } from '../../utils';

const {
  contentfulValues: {
    wirelessOrderDetails: {
      valueTwoYear: valueTwoYearEnglish,
      valueVoiceOnly: valueVoiceOnlyEnglish
    }
  }
} = EN;

const {
  contentfulValues: {
    wirelessOrderDetails: {
      valueTwoYear: valueTwoYearFrench,
      valueVoiceOnly: valueVoiceOnlyFrench
    }
  }
} = FR;

const contractTermTwoYearValueVariants = [
  valueTwoYearEnglish,
  valueTwoYearFrench
];
const devicePlanVoiceOnlyValueVariants = [
  valueVoiceOnlyEnglish,
  valueVoiceOnlyFrench
];

const PricingBar = ({
  formFields,
  isFormTouched,
  onSaveAndExit,
  onPreviousClick,
  onProceedClick,
  onBackClick,
  currentSubscriber,
  totalSubscribers,
  total,
  editingSubscriber,
  firstIncompleteSubscriber
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    formButtons: {
      continueButtonLabel,
      backLabel,
      saveContinueLaterButtonLabel,
      nextSubscriberLabel,
      previousSubscriberLabel,
      saveButtonLabel
    },
    contentfulValues: {
      wirelessOrderDetails: {
        valueByod,
        valueTablet,
        valueWatch,
        valueMobileHighSpeedSmartHub,
        valueUnlimitedForBusiness
      }
    }
  } = localizedStrings;

  const valueDevicePlan = getFieldValue(
    fieldSubscriberDetailsDevicePlan,
    formFields
  );

  const valueContractTerm = getFieldValue(
    fieldSubscriberDetailsContractTerm,
    formFields
  );

  const isDevicesOnly =
    formFields.subscriberDetailsExistingPhoneNumber &&
    formFields.subscriberDetailsExistingPhoneNumber.isVisible;

  return (
    <StatusBarWrapper>
      <div id="footer-high" style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', alignItems: 'center' }}>
        {valueContractTerm === contractTerm3Year[0] ||
        valueContractTerm === contractTerm3Year[1] ||
        valueContractTerm === valueByod ||
        valueDevicePlan === valueUnlimitedForBusiness ||
        valueDevicePlan === valueTablet ||
        valueDevicePlan === valueWatch ||
        valueDevicePlan === valueMobileHighSpeedSmartHub ||
        (contractTermTwoYearValueVariants.includes(valueContractTerm) &&
          devicePlanVoiceOnlyValueVariants.includes(valueDevicePlan)) ||
        isDevicesOnly ? (
          <TwoYear total={total} formFields={formFields} />
        ) : (
          <Regular total={total} />
        )}

        <ButtonsWrapper>
          <Flex>
            {editingSubscriber && !firstIncompleteSubscriber ? (
              <ButtonWrapper>
                <UDSButton
                  type="button"
                  onClick={e => onProceedClick(e)}
                  variant={{ priority: 'high' }}
                >
                  {saveButtonLabel}
                </UDSButton>
              </ButtonWrapper>
            ) : (
              <>
                <ButtonWrapper>
                  <UDSButton
                    type="button"
                    onClick={e => onBackClick(e)}
                    variant={{ priority: 'high' }}
                  >
                    {backLabel}
                  </UDSButton>
                </ButtonWrapper>
                <ButtonWrapper>
                  <UDSButton
                    type="button"
                    onClick={e => onSaveAndExit(e)}
                    variant={{ priority: 'high' }}
                    disabled={!isFormTouched}
                  >
                    {saveContinueLaterButtonLabel}
                  </UDSButton>
                </ButtonWrapper>
                {totalSubscribers > 1 && currentSubscriber > 1 && (
                  <ButtonWrapper>
                    <UDSButton
                      type="button"
                      onClick={e => onPreviousClick(e)}
                      variant={{ priority: 'high' }}
                    >
                      {previousSubscriberLabel}
                    </UDSButton>
                  </ButtonWrapper>
                )}
                <ButtonWrapper>
                  <UDSButton
                    type="button"
                    onClick={e => onProceedClick(e)}
                    variant={{ priority: 'high' }}
                  >
                    {currentSubscriber < totalSubscribers
                      ? nextSubscriberLabel
                      : continueButtonLabel}
                  </UDSButton>
                </ButtonWrapper>
              </>
            )}
          </Flex>
        </ButtonsWrapper>
      </div>
    </StatusBarWrapper>
  );
};

PricingBar.propTypes = {
  formFields: PropTypes.objectOf(PropTypes.any).isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  onPreviousClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  currentSubscriber: PropTypes.number.isRequired,
  totalSubscribers: PropTypes.number.isRequired,
  total: PropTypes.objectOf(PropTypes.any).isRequired,
  editingSubscriber: PropTypes.string.isRequired,
  firstIncompleteSubscriber: PropTypes.string.isRequired
};

export default PricingBar;
